import React, { useState } from 'react'
import classnames from 'classnames';
import { withNativeProps } from '@utils/NativeProps'
import { usePropsValue } from '@hooks/UsePropsValue'
import { useConfig } from '@components/config-provider/src'
import { isPromise } from '@utils/Validate'
import WebUI from '@utils/UpdatePrefixs';
import { SwitchProps } from './iSwitch'
import { SpinIcon } from './SpinIcon'

const defaultProps = {
  defaultChecked: false,
  visible: true,
}

function Switch (props: SwitchProps) {

  const {
    className,
    clsPrefix,
    fieldid,
    style={},
    disabled,
    readOnly,
    browserText,
    browserClassName,
    browserStyle,
    checkedText,
    uncheckedText,
    loading,
    visible,
    beforeChange,
    browser
  } = props;

  const _clsPrefix = `${clsPrefix}-switch`

  const disabledValue = disabled || loading || false
  const [changing, setChanging] = useState(false)
  const { locale } = useConfig()

  const [checked, setChecked] = usePropsValue({
    value: props.checked,
    defaultValue: props.defaultChecked,
    onChange: props.onChange,
  })

  async function onClick() {
    if (disabledValue || changing || browser || readOnly) {
      return
    }
    const nextChecked = !checked
    if (beforeChange) {
      setChanging(true)
      try {
        await beforeChange(nextChecked)
        setChanging(false)
      } catch (e) {
        setChanging(false)
        throw e
      }
    }

    const result = setChecked(nextChecked)

    if (isPromise(result)) {
      setChanging(true)
      try {
        await result
        setChanging(false)
      } catch (e) {
        setChanging(false)
        throw e
      }
    }
  }

  const cls = classnames(
    className,
    _clsPrefix,
    { [`${_clsPrefix}-checked`]: checked, },
    { [`${_clsPrefix}-disabled`]: disabledValue || changing || browser },
    { [`${_clsPrefix}-readonly`]: readOnly },
    { [`${_clsPrefix}-hidden`]: !visible, },
    { [`${_clsPrefix}-browser`]: browser, },
  )

  if (browser && browserText) {
    return (
      <div className={classnames(`${clsPrefix}-component-browser`)}>
        <div className={classnames(`${clsPrefix}-switch-browser`, { [`${browserClassName}`]: browserClassName })} style={browserStyle} fieldid={fieldid ? fieldid : undefined}>
          {browserText}
        </div>
      </div>
    );
  }

  return withNativeProps(
    props,
    <div
      onClick={onClick}
      className={cls}
      style={style}
      fieldid={fieldid}
      role='switch'
      aria-label={locale.Switch.name}
      aria-checked={checked}
      aria-disabled={disabledValue || browser || readOnly}
    >
      <div className={`${_clsPrefix}-checkbox`}>
        <div className={`${_clsPrefix}-handle`}>
          {((loading || changing) && !browser) && (
            <SpinIcon className={`${_clsPrefix}-spin-icon`} />
          )}
        </div>
        <div className={`${_clsPrefix}-inner`}>
          {checked ? checkedText : uncheckedText}
        </div>
      </div>
    </div>
  )
}

export default WebUI({ name: 'switch', defaultProps })(Switch)
